/* Nutrilight panel sections (nl-panel-*). Small helpers on top of lynx-redesign.js (which handles reveal + cart). */
(function () {
  'use strict';
  if (window.__nlPanel) return;
  window.__nlPanel = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Looping background videos: never autoplay with reduced motion, and pause while off screen. */
  var vio = null;
  function initVideos(root) {
    $$('.nlp video', root).forEach(function (v) {
      if (v.__nlp) return; v.__nlp = true;
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduce) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) { /* ignore */ } return; }
      if (!('IntersectionObserver' in window)) return;
      if (!vio) {
        vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var el = e.target;
            if (e.isIntersecting) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
            else { el.pause(); }
          });
        }, { threshold: 0.15 });
      }
      vio.observe(v);
    });
  }

  /* Comparison: on narrow screens, scroll the row so the current product's card is in view. */
  function initCompare(root) {
    $$('[data-nlp-compare]', root).forEach(function (sec) {
      if (sec.__nlp) return; sec.__nlp = true;
      var track = sec.querySelector('[data-nlp-track]');
      var cur = sec.querySelector('[data-current]');
      if (!track || !cur) return;
      function place() {
        if (track.scrollWidth <= track.clientWidth + 4) return;
        var peek = 28;
        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        track.scrollLeft = Math.max(0, cur.offsetLeft - pad - peek);
      }
      if (document.readyState === 'complete') place();
      else window.addEventListener('load', place, { once: true });
    });
  }

  function init(root) {
    root = root || document;
    initVideos(root);
    initCompare(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
